import { useEffect, useState } from 'react';

export default function WinnerTicker() {
  const [isPaused, setIsPaused] = useState(false);

  const winners = [
    { user: 'user_2***', amount: '$3,830', game: 'Sweet Bonanza' },
    { user: 'user_qc***', amount: '$5,240', game: 'Mahjong Ways 2', feature: 'Mega Feature' },
    { user: 'user_7k***', amount: '$2,150', game: 'Gates of Olympus' },
    { user: 'user_m9***', amount: '$8,920', game: 'Starlight Princess', feature: 'Free Spins' },
    { user: 'user_3x***', amount: '$4,560', game: 'Wild West Gold' },
    { user: 'user_p1***', amount: '$6,780', game: 'Book of Dead', feature: 'Bonus Round' },
    { user: 'user_8h***', amount: '$3,290', game: 'Dragon Hatch' },
    { user: 'user_5r***', amount: '$7,450', game: 'Fortune Tiger' },
  ];

  // Duplicate winners for seamless loop
  const duplicatedWinners = [...winners, ...winners];

  return (
    <section id="winners" className="py-4 md:py-6 bg-gradient-to-r from-[#061B3A] via-[#0D0E11] to-[#061B3A] border-y border-[#29A5FF]/20">
      <div className="relative overflow-hidden">
        <div 
          className={`flex gap-4 md:gap-8 ${isPaused ? '' : 'animate-marquee'}`}
          onMouseEnter={() => setIsPaused(true)}
          onMouseLeave={() => setIsPaused(false)}
        >
          {duplicatedWinners.map((winner, index) => (
            <div 
              key={index}
              className="flex items-center gap-2 md:gap-3 whitespace-nowrap bg-white/5 backdrop-blur-sm border border-[#29A5FF]/30 rounded-full px-4 md:px-6 py-2 md:py-3 hover:border-[#EFBF65]/50 transition-all duration-300"
            >
              <div className="w-2 h-2 bg-[#29A5FF] rounded-full animate-pulse"></div>
              <span className="text-[#29A5FF] font-medium text-xs md:text-sm" style={{ fontFamily: 'Montserrat, sans-serif' }}>
                {winner.user}
              </span>
              <span className="text-white/70 text-xs" style={{ fontFamily: 'Montserrat, sans-serif' }}>
                just won
              </span>
              <span className="text-[#EFBF65] font-bold text-sm md:text-base" style={{ fontFamily: 'Poppins, sans-serif' }}>
                {winner.amount}
              </span>
              {/* <span className="text-white/70 text-xs" style={{ fontFamily: 'Montserrat, sans-serif' }}>
                on
              </span>
              <span className="text-white font-semibold text-xs md:text-sm" style={{ fontFamily: 'Montserrat, sans-serif' }}>
                {winner.game}
              </span> */}
              {winner.feature && (
                <>
                  <span className="text-white/50 text-xs">•</span>
                  <span className="text-[#29A5FF] text-xs font-medium" style={{ fontFamily: 'Montserrat, sans-serif' }}>
                    {winner.feature}
                  </span>
                </>
              )}
            </div>
          ))}
        </div>
      </div>

      <style>{`
        @keyframes marquee {
          0% {
            transform: translateX(0);
          }
          100% {
            transform: translateX(-50%);
          }
        }
        .animate-marquee {
          animation: marquee 25s linear infinite;
        }
      `}</style>
    </section>
  );
}
